import { render } from "./Knowledgebase2.vue?vue&type=template&id=6eaeff7e&scoped=true"
import script from "./Knowledgebase2.vue?vue&type=script&lang=js"
export * from "./Knowledgebase2.vue?vue&type=script&lang=js"

import "./Knowledgebase2.vue?vue&type=style&index=0&id=6eaeff7e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6eaeff7e"

export default script